<template>
	<div class="animated fadeIn">
		<DatasetHeaderV2 :record_id="record_id" type="dataset">
			<div class="row">
				<div class="col-12">
					<b-card>
						<form id="container__form" @submit.prevent="save">
							<tooltip label="dataset name" placement="right">
								<input
									name="ds_name"
									v-model="record.ds_name"
									v-validate="'required'"
									:class="{'form-control': true, 'is-invalid': errors.has('ds_name')}"
									type="text"
								/>
								<span
									v-show="errors.has('ds_name')"
									class="help invalid-feedback"
								>{{ $t(errors.first('ds_name')) }}</span>
							</tooltip>
							<tooltip label="related to services" label-for="services_list">
								<b-form-group :horizontal="false">
									<b-form-select
										id="services_list"
										:plain="true"
										:multiple="true"
										:options="servicesOptions"
										v-model="record.ds_services"
									></b-form-select>
								</b-form-group>
							</tooltip>
						</form>
						<hr />
						<field-structures
							:schema="record.ds_schema"
							@fieldChanged="handleFieldChanging"
							@change="handleOnChangeSchema"
						></field-structures>
					</b-card>
				</div>
				<ButtonSubmit />
			</div>
		</DatasetHeaderV2>
	</div>
</template>
<script>
	import axios from 'axios'
	import fieldStructures from '../../components/fieldStructures'
	import {ButtonSubmit, DatasetHeaderV2} from '../../components'

	export default {
		name: 'datasetForm',
		components: {
			ButtonSubmit,
			DatasetHeaderV2,
			fieldStructures,
		},
		data() {
			return {
				record_id: 0,
				record: {
					ds_name: '',
					ds_schema: [],
					ds_services: [],
				},
				servicesOptions: [],
			}
		},
		methods: {
			fetchDataSetStructure(id, callback = () => {}) {
				this.record_id = id
				this.$root.loader = true
				if (!isNaN(id) && id >= 1) {
					axios.get('/dataset/browse/' + this.record_id).then((response) => {
						
						if (response.data.status == 1) {
							this.record = Object.assign(this.record, response.data.data)
						}
						this.$root.loader = false
					})

					callback && callback()
				} else {
					this.$root.loader = false
					callback && callback()
					// this.$router.push({
					// 	path: '/dataset',
					// })
				}
			},

			handleOnChangeSchema(schema) {
				this.record.ds_schema = schema
			},

			async handleFieldChanging({newField, oldField}) {
				const {data} = await axios.put(`/dataset/fields/${this.record_id}`, {
					new_field: newField,
					old_field: oldField,
				})

				console.log(data)
			},

			save(e) {
				e = e || window.event
				e.preventDefault()
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.$root.loader = true
						axios
							.post('/dataset/save/' + this.record_id, {
								...this.record,
								ds_type: 'dataset',
							})
							.then((response) => {
								this.$root.loader = false
								if (response.data.status === 1) {
									this.$store.commit('update_breadcrumb_history', {
										mode: 'dataset',
										id: this.record_id,
										change_to: this.record.ds_name,
									})
									this.$router.push('/dataset/' + response.data.id)
								}
							})
					} else {
						// invalid
						this.$root.loader = false
					}
				})
			},
		},

		mounted() {
			
			this.fetchDataSetStructure(parseInt(this.$route.params.id), () => {
				
				if (this.$store.state.go_services.length) {
					var recursiveServices = function(services, edited_services = []) {
						if (!services.length) return edited_services
						var service_one = services.splice(0, 1)[0]
						edited_services = [].concat(edited_services, {
							text: service_one.service_name,
							value: service_one.service_id,
							disabled: !service_one.service_status,
						})
						return recursiveServices(services, edited_services)
					}
					this.servicesOptions = recursiveServices(this.$store.state.go_services.slice())
				}
			})
		},
	}
</script>
